import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import deviceUserQueries from 'src/gql/queries/deviceUser';
import userQueries from 'src/gql/queries/user';
import workspaceMutations from 'src/gql/mutations/workspace';

export const useGetDeviceUsersByDeviceId = ({ deviceId, onCompleted } = {}) => {
  const response = useQuery(deviceUserQueries.GET_DEVICE_USERS_BY_DEVICE, {
    variables: {
      deviceId,
    },
    onCompleted,
  });

  return { ...response, data: response.data?.getDeviceUsersByDevice };
};

export const useIsUserRegistered = () => {
  const response = useLazyQuery(userQueries.IS_USER_REGISTERED);

  return response;
};

export const useRemoveUserFromWorkspace = ({ onCompleted, onError } = {}) => {
  const response = useMutation(workspaceMutations.REMOVE_USER_WORKSPACE, {
    onCompleted: (data) => onCompleted(data),
    onError: () => onError,
  });

  return response;
};
